import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { VendorService } from '../shared/vendor.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InstructionsComponent } from '../instructions/instructions.component';
import { StateNames } from '../models/vendor.model';
import { ConfigureFormFieldsView } from '../models/ConfigureFormFieldsView';

@Component({
  selector: 'app-member-details',
  templateUrl: './member-details.component.html',
  styleUrls: ['./member-details.component.css', '../shared/css/common.css']
})
export class MemberDetailsComponent implements OnInit {

  memberFormData: any;
  formdata: any | null;
  payorkey: number;
  title: string = 'Member';
  isformloaded = false;
  isInstruction = false;
  instructionText!: string | null;
  isFormsValid = false;

  memberFormData1: any = {};
  memberFormData2: any = {};
  memberFormData3: any = {};

  statelist: StateNames[] = [];
  primaryColor?: string = '';
  internalInvolvedPartiesKey = 0;
  isNameRequired = false;
  configureFormFields: ConfigureFormFieldsView[] = [];

  memberFormPart1: FormGroup;
  memberFormPart2: FormGroup;
  memberFormPart3: FormGroup;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private vendorService: VendorService,
    private cdref: ChangeDetectorRef,
    private modalService: NgbModal
  ) {
    this.formdata = JSON.parse(sessionStorage.getItem('activeformdata') ?? '{}');
    this.memberFormData = this.formdata.memberDetails;
    this.memberFormData1.controls = this.formdata.memberDetails.controls.slice(0, 8);
    this.memberFormData2.controls = this.formdata.memberDetails.controls.slice(8, 17);
    this.memberFormData3.controls = this.formdata.memberDetails.controls.slice(17, 26);
    this.payorkey = parseInt(sessionStorage.getItem('payorkey') ?? '0');

    this.memberFormPart1 = this.fb.group({});
    this.memberFormPart2 = this.fb.group({});
    this.memberFormPart3 = this.fb.group({});
  }

  ngOnInit(): void {
    const involvedTypeCtrl = this.formdata.witnessDetails.controls.find((x: any) => x.name === 'involvedType');
    if (involvedTypeCtrl?.value) {
      this.internalInvolvedPartiesKey = involvedTypeCtrl.value;
      this.title = involvedTypeCtrl.options.find((y: any) => y.value == involvedTypeCtrl.value)?.key ?? 'Member';
    }

    this.vendorService.getLeadHeaders(this.payorkey).subscribe((result) => {
      this.isInstruction = result.IsInstructionEnbaled;
      this.instructionText = result.Instruction?.replace('<img ', '<img title="Header" ');
    });

    this.vendorService.getStateNames().subscribe((result) => {
      this.statelist = result;
      this.memberFormData.controls.find((x: any) => x.name === 'mState').options =
        result.map((x) => ({ value: x.Abbreviation, key: x.Name }));
    });

    this.vendorService
      .getSubjectRequiredFieldsByInvolvedParty(this.internalInvolvedPartiesKey, this.payorkey)
      .subscribe((result) => {
        this.isNameRequired = !!result.Name;
        this.configureFormFields = result.ConfigureFormFields ?? [];

        const markReq = (ctrlName: string, required: boolean) => {
          const ctrl =
            this.memberFormData1.controls.find((x: any) => x.name === ctrlName) ||
            this.memberFormData2.controls.find((x: any) => x.name === ctrlName) ||
            this.memberFormData3.controls.find((x: any) => x.name === ctrlName);
          if (ctrl) ctrl.validators.required = required;
        };

        markReq('mFirstName', !!result.Name);
        markReq('mLastName', !!result.Name);
        markReq('mDateOfBirth', !!result.DateofBirth);
        markReq('mGender', !!result.Gender);
        markReq('mAddress1', !!result.AddressLine1);
        markReq('mCity', !!result.City);
        markReq('mState', !!result.State);
        markReq('mZip', !!result.ZipCode);
        markReq('mPrimaryPhone', !!result.Phone);
        markReq('mEmail', !!result.Email);

        this.memberFormData1 = { controls: [...this.memberFormData1.controls] };
        this.memberFormData2 = { controls: [...this.memberFormData2.controls] };
        this.memberFormData3 = { controls: [...this.memberFormData3.controls] };
        this.isformloaded = true;

        setTimeout(() => {
          this.applyReactiveValidators(result);
          this.setConfiguredFormFields();
          this.cdref.detectChanges();
        }, 80);
      });

    setTimeout(() => {
      const color = localStorage.getItem('primaryCssColor');
      if (color) {
        this.primaryColor = color;
        document.documentElement.style.setProperty('--primary-color', this.primaryColor);
      }
    }, 0);
  }

  /** Sync reactive form controls validators */
  private applyReactiveValidators(result: any): void {
    const setReq = (form: FormGroup, field: string, required: boolean) => {
      const ctrl = form.get(field);
      if (!ctrl) return;
      if (required) {
        ctrl.addValidators(Validators.required);
        const ctrlForm =
            this.memberFormData1.controls.find((x: any) => x.name === field) ||
            this.memberFormData2.controls.find((x: any) => x.name === field) ||
            this.memberFormData3.controls.find((x: any) => x.name === field);
          if (ctrlForm) ctrlForm.validators.required = required;
      }
      else ctrl.removeValidators(Validators.required);
      ctrl.updateValueAndValidity({ emitEvent: false });
    };

    setReq(this.memberFormPart1, 'mFirstName', !!result.Name);
    setReq(this.memberFormPart1, 'mLastName', !!result.Name);
    setReq(this.memberFormPart1, 'mDateOfBirth', !!result.DateofBirth);
    setReq(this.memberFormPart1, 'mGender', !!result.Gender);
    setReq(this.memberFormPart1, 'mOther', !!result.Other);
    setReq(this.memberFormPart2, 'mID', !!result.ManualSubjectID);
    setReq(this.memberFormPart2, 'mSSN', !!result.SSN);
    setReq(this.memberFormPart2, 'mMedicaidId', !!result.MedicaidId);
    setReq(this.memberFormPart2, 'mMedicareId', !!result.MedicareNo);
    setReq(this.memberFormPart2, 'mOtherId', !!result.OtherID);
    setReq(this.memberFormPart2, 'mPlan', !!result.Plan);
    setReq(this.memberFormPart2, 'mProgram', !!result.Program);
    setReq(this.memberFormPart2, 'mLOB', !!result.LOB);
    setReq(this.memberFormPart2, 'mGroup', !!result.Group);
    setReq(this.memberFormPart3, 'mAddress1', !!result.AddressLine1);
    setReq(this.memberFormPart3, 'mCity', !!result.City);
    setReq(this.memberFormPart3, 'mState', !!result.State);
    setReq(this.memberFormPart3, 'mCounty', !!result.County);
    setReq(this.memberFormPart3, 'mZip', !!result.ZipCode);
    setReq(this.memberFormPart3, 'mPrimaryPhone', !!result.Phone);
    setReq(this.memberFormPart3, 'mSecondaryPhone', !!result.SecondaryPhone);
    setReq(this.memberFormPart3, 'mEmail', !!result.Email);

    this.recheckFormValidity();
  }

  childInitComplete(): void {
    this.memberFormPart1.valueChanges.subscribe(() => this.recheckFormValidity());
    this.memberFormPart2.valueChanges.subscribe(() => this.recheckFormValidity());
    this.memberFormPart3.valueChanges.subscribe(() => this.recheckFormValidity());

    this.recheckFormValidity();
    this.cdref.detectChanges();
  }

  private recheckFormValidity(): void {
    const allValid =
      this.memberFormPart1.valid &&
      this.memberFormPart2.valid &&
      this.memberFormPart3.valid &&
      this.dobValidation();

    if (this.isFormsValid !== allValid) {
      this.isFormsValid = allValid;
      this.cdref.detectChanges();
    }
  }

  valueChange(data: any): void {
    if (data?.name === 'mState') {
      const abbrev = this.statelist.find((y) => y.Id == data.value.target.selectedIndex)?.Abbreviation ?? '';
      this.vendorService.getStateCounties(abbrev).subscribe((result) => {
        this.memberFormData3.controls.find((x: any) => x.name === 'mCounty').options = result.map((x) => ({
          value: x.County,
          key: x.County,
        }));
      });
      this.memberFormData3.controls.find((x: any) => x.name === 'mCounty').disabled = false;
    }
    if (data?.name === 'mDateOfBirth') {
      this.dobValidation();
    }
    this.recheckFormValidity();
  }

  memberDetailsSubmit(): void {
    if (!this.isFormsValid) return;
    const tempArr = {
      controls: [
        ...this.memberFormData1.controls,
        ...this.memberFormData2.controls,
        ...this.memberFormData3.controls,
      ],
    };
    this.formdata.memberDetails = tempArr;
    sessionStorage.setItem('activeformdata', JSON.stringify(this.formdata));

    const profileKey = sessionStorage.getItem('selectedProfileMasterTypeKey');
    if (profileKey === '2') this.router.navigate(['questions']);
    else this.router.navigate(['validateParticipant']);
  }

  back(): void {
    const tempArr = {
      controls: [
        ...this.memberFormData1.controls,
        ...this.memberFormData2.controls,
        ...this.memberFormData3.controls,
      ],
    };
    this.formdata.memberDetails = tempArr;
    sessionStorage.setItem('activeformdata', JSON.stringify(this.formdata));
    this.router.navigate(['referal']);
  }

  openInstruction(): void {
    const modalRef = this.modalService.open(InstructionsComponent, { size: 'lg', ariaLabelledBy: 'Instructions' });
    modalRef.componentInstance.name = this.instructionText;
  }

  /** Label configuration logic */
  setConfiguredFormFields(): void {
    const oldLabel = this.memberFormData2.controls.find((x: any) => x.name === 'mID').label;
    const updatedLabel = this.manualFieldConfig(
      'OnlineIntake',
      'InvolvedParty',
      'InvolvedPartyType',
      'MemberSubjectId',
      oldLabel
    );
    this.memberFormData2.controls.find((x: any) => x.name === 'mID').label = updatedLabel;
  }

  manualFieldConfig(
    formCategory: string,
    formName: string,
    subFormName: string,
    fieldName: string,
    defaultValue: string
  ): string {
    let result = defaultValue;
    if (this.configureFormFields?.length > 0) {
      for (const field of this.configureFormFields) {
        if (
          field.FormCategory?.toLowerCase() === formCategory.toLowerCase() &&
          field.FormName?.toLowerCase() === formName.toLowerCase() &&
          field.SubFormName?.toLowerCase() === subFormName.toLowerCase() &&
          field.FieldName?.toLowerCase() === fieldName.toLowerCase() &&
          field.FormTypeKey == this.internalInvolvedPartiesKey
        ) {
          result = field.LabelValue ?? defaultValue;
        }
      }
    }
    return result;
  }

  private dobValidation(): boolean {
    let result = true;
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const dobCfg =
      this.memberFormData1.controls.find((x: any) => x.name === 'mDateOfBirth') ||
      this.memberFormData2.controls.find((x: any) => x.name === 'mDateOfBirth') ||
      this.memberFormData3.controls.find((x: any) => x.name === 'mDateOfBirth');

    const dob = dobCfg && dobCfg.value ? new Date(dobCfg.value) : null;
    let err = '';
    if (dob && dob > today) {
      err = 'Date cannot be in the future.';
      result = false;
    }

    const el = document.getElementById('mDateOfBirth_Error');
    if (el) el.textContent = err;

    const ctrl = this.memberFormPart1.get('mDateOfBirth') || this.memberFormPart2.get('mDateOfBirth') || this.memberFormPart3.get('mDateOfBirth');
    if (ctrl) {
      if (!result) {
        ctrl.setErrors({ ...(ctrl.errors || {}), futureDate: true });
      } else {
        if (ctrl.errors && ctrl.errors['futureDate']) {
          const { futureDate, ...rest } = ctrl.errors;
          Object.keys(rest).length ? ctrl.setErrors(rest) : ctrl.setErrors(null);
        }
      }
    }
    return result;
  }
}
